import { debounce } from 'lodash-es';

export const PXAmigobannerHome = (function () {
	'use strict';

	let amigoBanners;

	function init() {
		
	}

	return {
		init: init,
	};
})();
